import Vue from "vue";
import App from "./App";
import router from "./router";
import api from "./api";
import store from "./store/index";

Vue.config.productionTip = false;

/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  created() {
  },
});

api.getUser().then((response) => {
  app.$store.commit({
    type: "loginUser",
    user: response,
  });
}).catch((error) => {
  app.$store.commit({
    type: "loginUser",
    user: false,
  });
  console.log("error", error);
});



// WEBPACK FOOTER //
// ./src/main.js